<template>
  <div class="row" style="margin-bottom:10px;">
    <div class="col-lg-12">
      <br />
      <span><a href="https://www.gofar.co/refund-policy/" target="_blank">Refund policy</a>&nbsp;&nbsp;</span>|
      <span><a href="https://www.gofar.co/privacy-policy/" target="_blank">Privacy policy</a>&nbsp;&nbsp;</span>|
      <span><a href="https://www.gofar.co/terms-of-service/" target="_blank">Terms of service</a>&nbsp;&nbsp;</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CheckoutFooter'
};
</script>
